import {
  forwardRef,
  type ForwardedRef,
  type ElementType,
  type PropsWithChildren,
} from "react";
import type { ThemeTokens } from "@boi/react-design-tokens";
import { type CoreTypography } from "@boi/components-core";

import * as S from "./TypographyBase.styled";

export type TypographyBaseProps = PropsWithChildren & {
  component: ElementType;
  variant: CoreTypography.Variant;
  fontFamily?: CoreTypography.FontFamily;
  color?: "inherit" | ThemeTokens["themeColor" | "color"];
  noWrap?: boolean;
  testID?: string;
};

function UnwrappedTypographyBase(
  props: TypographyBaseProps,
  ref: ForwardedRef<any>
) {
  const {
    variant,
    component,
    color,
    fontFamily,
    noWrap,
    testID,
    ...otherProps
  }: TypographyBaseProps = props;

  return (
    <S.TypographyBase
      {...otherProps}
      ref={ref}
      as={component}
      $variant={variant}
      $color={color}
      $fontFamily={fontFamily}
      $noWrap={noWrap}
      data-testid={testID}
    />
  );
}

export const TypographyBase = forwardRef(UnwrappedTypographyBase);
